import { getAuthHeaders } from "@/utils/authManager";
import { httpCall } from "../../../common/util";
import config from '../../../containers/WorkkardDetail/endpoints';

const ep = config.api.endpoints

export const fetchOrgProfileDataApi = () => {
  return httpCall({
    method: ep.fetchOrgProfileDataEP.method,
    headers: getAuthHeaders(),
    url: ep.fetchOrgProfileDataEP.url,
  });
};

export const updateOrgProfileDataApi = (data) => {
  return httpCall({
    method: ep.updateOrgProfileDataEP.method,
    headers: getAuthHeaders(),
    url: ep.updateOrgProfileDataEP.url,
    data,
  });
};

export const updateOrgServiceLocationApi = (data) => {
  return httpCall({
    method: ep.updateOrgServiceLocationEP.method,
    headers: getAuthHeaders(),
    url: ep.updateOrgServiceLocationEP.method,
    data,
  });
};

export const updateOrgSkillsetApi = (data) => {
  return httpCall({
    method: ep.updateOrgSkillsetApiEP.method,
    headers: getAuthHeaders(),
    url: ep.updateOrgSkillsetApiEP.url,
    data,
  });
};

export const saveSkilsetTag = (data) => {
  return httpCall({
    method: ep.saveSkillsetTags.method,
    headers: getAuthHeaders(),
    url: ep.saveSkillsetTags.url,
    data,
  });
};
